import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentUser, selectFcmToken } from '../../Auth/authSlice';
import { webview } from '../../../app/api/webview';
import {
  Box,
  Tabs,
  Tab,
  useMediaQuery,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  styled,
  ListItemButton,
  Tooltip,
  Typography,
  IconButton,
  Paper,
  Divider,
} from '@mui/material';
import { getAuthTokenWithoutBasicForLeave } from '../utility/AuthKey';
import Overlay from './Overlay';
import {
  ConnectWithoutContact,
  VideoCall,
  ReceiptLong,
  FlightTakeoff,
  Groups,
  ArrowBackIosNewRounded,
  EmojiEventsOutlined,
  CardGiftcardOutlined,
  CelebrationOutlined,
  EventOutlined,
  ArrowCircleRightOutlined,
  ArrowRightAltRounded,
  ArrowForwardIosRounded,
} from '@mui/icons-material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { variants } from '../../../variants/variants';
import { selectIsOutlet, toggleOutlet } from '../../Announcement/announcementSlice';
import { encryptForResumeX } from '../../../utils/crypto';
import axios from 'axios';

const GatewayBox = () => {
  const user = useSelector(selectCurrentUser);
  const hideGeneralServices = ['sports_social_celebration', 'learning_development'].includes(user?.username);
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  // const [isOutlet, setIsOutlet] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const dispatch = useDispatch();
  const isOutlet = useSelector(selectIsOutlet);
  const fcm = useSelector(selectFcmToken);
  const urlQuery = `?header=${user?.details?.header}&travelData=${user?.details?.travelData?.travelToken}&userId=${user?.empId}&fcm=${
    fcm || 'abcd'
  }`;
  // const { pathname } = useLocation();
  // const pathArray = pathname.split('/');
  // const isGatewayBox = pathArray[pathArray.length - 1] == 'gatewaybox';
  // const isSecondGatewayBox = pathArray[pathArray.length - 2] == 'gatewaybox';
  // console.log('isGatewayBox', isGatewayBox, pathArray[pathArray.length - 1]);
  // useEffect(() => {
  //   const handlePopState = () => {
  //     if (isGatewayBox) {
  //       navigate('/home/announcement/gnn');
  //     } else if (isSecondGatewayBox) {
  //       dispatch(toggleOutlet(false));
  //       navigate('/home/announcement/gatewaybox');
  //     }
  //   };

  //   window.addEventListener('popstate', handlePopState);
  //   return () => window.removeEventListener('popstate', handlePopState);
  // }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      try {
        console.log('message', event.data);
        const message = event.data;
        if (message.type == 'GBOXClose') {
          // dispatch(toggleOutlet(false));
          navigate('/home/announcement/gatewaybox');
          console.log('GBOXClose');
        }
      } catch (error) {}
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleTabClick = (tab, index) => {
    if (tab.label == 'Travel Desk') {
      window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'page', data: 'travelDesk' }));
      return;
    }
    window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'pageOpen', data: 'true' }));
    // dispatch(toggleOutlet(true));
    if (tab.label == 'RnR' || tab.label == 'Shabash') {
      navigate(`${tab.path}`);
      return;
    }
    navigate(`/home/announcement/gbox/${tab.path}`);
  };
  
  const encryptedPassword = user?.password ? btoa(encryptForResumeX(user.password)) : '';

  // useEffect(()=>{
  //   document.addEventListener("message", function(event) {
  //     const message = JSON.parse(event.data);
  //     console.log("Received message:", message);
  //     if (message.type === "Outlet") {
  //       dispatch(toggleOutlet(message.data));
  //       console.log('outlet message',message.data)
  //     }
  //   });
  // },[])

  // useEffect(()=>{
  //   dispatch(toggleOutlet(isOutlet));

  // },[isOutlet])

  // const handleNavigateBack = () => {
  //   // window.history.back()
  //   setIsOutlet(false);
  //   setTabIndex(0);
  //   navigate('/home/announcement/gatewaybox');
  // };

  useEffect(() => {
    const fetchCode = async () => {
      try {
        const token = await axios.get('https://gnnstaging.thegatewaycorp.com/tdsk/api/common/GetCountryCodes');
        console.log('GetCountryCodes:', token);
      } catch (error) {
        console.error('Error fetching GetCountryCodes:', error);
      }
    }

    fetchCode();
  }, []);

  const tabs = [
    {
      label: 'Connect',
      icon: <ConnectWithoutContact />,
      url: webview.Connect.ResumeX(user?.username, encryptedPassword),
      comingSoon: false,
      path: 'connect',
      subtitle: 'Network and collaborate effectively',
    },
    {
      label: 'Conference Room',
      icon: <Groups />,
      url: webview.ConferenceRoomBooking,
      comingSoon: true,
      path: 'conference-room',
      subtitle: 'Book a conference room',
    },
    {
      label: 'Meeting Platform',
      icon: <VideoCall />,
      url: webview.Meetingplatform,
      comingSoon: true,
      path: 'meeting-platform',
      subtitle: 'Seamless virtual meeting solution',
    },
    // {
    //   label: 'Travel Desk',
    //   icon: <FlightTakeoff />,
    //   url: webview.Travel_desk,
    //   comingSoon: true,
    //   path: 'travel-desk',
    //   subtitle: 'Assistance for your travel bookings',
    // },
    {
      label: 'Reimbursement',
      icon: <ReceiptLong />,
      url: `${webview.TD_Reimbursement}/${urlQuery}`,
      // url: `${webview.TD_Reimbursement}/${JSON.stringify(user.details)}`,
      comingSoon: false,
      path: 'reimbursement',
      subtitle: 'Claim your expenses with ease',
    },
    // { label: 'Gatepass', icon: <MeetingRoom />, url: webview.GPTs, comingSoon: false },
  ];

  const tabsForMobile = [
    ...tabs.filter((tab) => tab.label != 'Reimbursement'),
    // {
    //   label: 'RnR',
    //   icon: <EmojiEventsOutlined />,
    //   path: '/home/rnr/winners',
    //   subtitle: 'Recognition is the greatest motivator',
    //   comingSoon: true,
    // },
    // {
    //   label: 'Gift',
    //   icon: <CardGiftcardOutlined />,
    //   path: '/home/gift',
    //   subtitle: 'Gateway Internal Fast Track Program',
    //   comingSoon: true,
    // },
    // {
    //   label: 'Shabash',
    //   icon: <CelebrationOutlined />,
    //   path: '/home/shabash/winners',
    //   subtitle: 'Shabash is the greatest motivator',
    //   comingSoon: true,
    // },

    {
      label: 'Travel Desk',
      icon: <FlightTakeoff />,
      url: webview.Travel_desk,
      comingSoon: true,
      path: 'travel-desk',
      subtitle: 'Assistance for your travel bookings',
    },
    {
      label: 'Reimbursement',
      icon: <ReceiptLong />,
      url: `${webview.TD_Reimbursement}/${JSON.stringify(user.details)}`,
      comingSoon: false,
      path: 'reimbursement',
      subtitle: 'Claim your expenses with ease',
    },
    {
      label: 'Leave',
      icon: <EventOutlined />,
      path: 'leave',
      subtitle: 'Request and manage your time off',
      comingSoon: false,
    },
    {
      label: 'Wall of Achievements',
      icon: <EmojiEventsOutlined />,
      path: 'wall-of-achievements',
      subtitle: 'Celebrate achievements and milestones',
      comingSoon: true,
    },
  ];

  return (
    <Box sx={{ width: '100%', backgroundColor: 'background.paper', p: 0, height: '100%' }}>
      {isMobile ? (
        <Box
          sx={{
            height: '100%',
            border: 1,
            borderRadius: variants.boxRadius.MAIN,
            borderColor: 'divider',
            overflow: 'scroll',
          }}
        >
          <List sx={{ height: '100%' }}>
            {tabsForMobile
              .filter((tab) => !hideGeneralServices || !['Travel Desk', 'Reimbursement', 'Leave'].includes(tab.label))
              .map((tab, index) => (
              <Box key={index}>
                <ListItem
                  disablePadding
                  key={index}
                  onClick={() => {
                    handleTabClick(tab, index);
                  }}
                >
                  <ListItem
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: 'transparent',
                      },
                      '&.Mui-focusVisible': {
                        backgroundColor: 'transparent',
                      },
                      '&:hover': {
                        backgroundColor: 'transparent', // optional: remove hover color
                      },
                      '&:active': {
                        backgroundColor: 'transparent',
                      },
                    }}
                  >
                    <ListItemIcon>{tab.icon}</ListItemIcon>
                    <ListItemText primary={tab.label} secondary={tab.subtitle} />
                  </ListItem>
                  <ListItemIcon>
                    <ArrowForwardIosRounded />
                  </ListItemIcon>
                </ListItem>
                <Divider />
              </Box>
            ))}
          </List>
        </Box>
      ) : (
        // isOutlet ? (
        //   <>
        //     {/* <Box
        //       sx={{
        //         display: 'flex',
        //         justifyContent: 'flex-start',
        //         width: '100%',
        //         p: 1,
        //         border: 1,
        //         borderColor: 'divider',
        //         background: variants.boxBackground.NAVBAR,
        //         borderRadius: variants.boxRadius.NAVBAR,
        //         alignItems: 'center',
        //       }}
        //     >
        //       <Tooltip title={'helllo'}>
        //         <IconButton
        //           id="backToHome"
        //           onClick={handleNavigateBack}
        //           sx={{
        //             p: 0,
        //             pr: 1,
        //             display: 'flex',
        //           }}
        //         >
        //           <ArrowBackIosNewRounded />
        //         </IconButton>
        //       </Tooltip>
        //       <Typography component={'div'} ml={1} sx={{ fontSize: variants.BODY }}>
        //         {tabsForMobile[tabIndex].label}
        //       </Typography>
        //     </Box> */}
        //     <Outlet />
        //   </>
        // ) : (
        // <Grid
        //   sx={{
        //     display: 'flex',
        //     justifyContent: 'center',
        //     height: 'calc(100vh-250px)',
        //     alignItems: 'flex-start',
        //     border:1,
        //     borderRadius: variants.boxRadius.NAVBAR,
        //     borderColor: 'divider',
        //     overflowY:"scroll",
        //   }}
        // >
        //   <Box
        //     sx={{
        //       width: '100%',
        //       bgcolor: 'background.paper',
        //       display: 'flex',
        //       gap:1,
        //       height: 'auto',
        //       flexWrap: 'wrap',
        //       justifyContent: 'center',
        //       p:1
        //     }}
        //   >
        //     {/* <nav aria-label="main mailbox folders"> */}
        //     {tabs.map((tab, index) => (
        //       <Paper
        //         sx={{
        //           width: '120px',
        //           height: '120px',
        //           display: 'flex',
        //           flexDirection: 'column',
        //           justifyContent: 'center',
        //           alignItems: 'center',
        //           gap: 1,
        //         }}
        //         elevation={2}
        //         onClick={() => {
        //           handleTabClick(tab, index);
        //         }}
        //       >
        //         <IconButton sx={{fontSize:variants.BODY}}>{tab.icon}</IconButton>
        //         <Typography component={'div'} sx={{ fontSize: variants.TINY, textAlign: 'center' }}>
        //           {tab.label}
        //         </Typography>
        //       </Paper>
        //     ))}
        //     {/* </nav> */}
        //   </Box>
        // </Grid>

        // )
        <>
          <Tabs
            value={tabIndex}
            key={tabIndex}
            onChange={handleTabChange}
            aria-label="Gateway Box tabs"
            variant={isMobile ? 'scrollable' : 'fullWidth'}
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              color: 'black',
              backgroundColor: 'background.default',
              border: 1,
              borderColor: 'divider',
              borderRadius: 1,
              mb: 0,
              borderColor: 'divider',
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              '& .MuiTab-root': {
                color: 'grey',
                minHeight: '48px',
                fontSize: {
                  xs: '0.75rem',
                  sm: '0.875rem',
                  md: '1rem',
                  lg: '1rem',
                  xl: '1rem',
                },
                px: {
                  xs: 1,
                  sm: 1,
                  md: 1,
                },
              },
              '& .Mui-selected': {
                color: 'black !important',
              },
              '& .MuiTabs-indicator': {
                backgroundColor: 'text.primary',
                height: 2,
              },
              '& .MuiTabs-scrollButtons': {
                '&.Mui-disabled': {
                  opacity: 0.5, // Makes the disabled button look inactive
                  cursor: 'not-allowed', // Changes the cursor to indicate it's disabled
                },
              },
            }}
          >
            {tabs
              .filter((tab) => !hideGeneralServices || !['Travel Desk', 'Reimbursement', 'Leave'].includes(tab.label))
              .map((tab, index) => (
              <Tab
                key={index}
                label={tab.label}
                icon={tab.icon}
                iconPosition="start"
                sx={{
                  textTransform: 'none',
                  // fontWeight: 'bold',
                  fontSize: {
                    xs: '0.75rem',
                    sm: '0.875rem',
                    md: '1rem',
                    lg: '1rem',
                    xl: '1rem',
                  },
                  px: {
                    xs: 1,
                    sm: 2,
                    md: 3,
                  },
                }}
              />
            ))}
          </Tabs>
          <Grid
            container
            sx={{
              height: 'calc(100vh - 130px)',
              borderRadius: '10px',
              overflow: 'hidden',
              border: 1,
              borderColor: 'divider',
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              borderTop: 0,
              position: 'relative',
            }}
          >
            {tabs[tabIndex].comingSoon ? (
              <Box sx={{ backgroundColor: 'white' }}>
                <Overlay />
              </Box>
            ) : (
              <iframe src={tabs[tabIndex].url} height="100%" width="100%" style={{ border: 0 }} />
            )}
          </Grid>
        </>
      )}
    </Box>
  );
};

export default GatewayBox;
